// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__cerJ9","header":"MergedInvoice_header__BaHCO"};